"use client";
import SliderNoArrows from "@/components/Carousel/SliderNoArrows";
import Testimonial from "@/components/Text/Testimonial";
import { TestimonialLight, TestimonialYellow } from "@/stories/Testemonial.stories";
import { shuffle } from "@/utils";
import { SwiperSlide } from "swiper/react";
import testimonials from "../../../../public/content/testimonials.json";
import Card from "@/components/Cards/Card";
import { CardMdColor } from "@/stories/Card.stories";
import Triangles from "@/components/Triangles";
import Newsletter from "@/components/Cards/Newsletter";
import Title from "@/components/Text/Title";
import PlayerInPage from "@/components/Player/PlayerInPage";
import Text from "@/components/Text/Text";
import SideBySideText from "@/components/Text/SideBySideText";
import { sendGTMEvent } from "@/components/Analytics";

export default function ForschungsergebnisseLayout() {
    const colorCards = [
        {
            title: "Die eigene Energie ist die Beste",
            text: "Unsere Energie hat eine einzigartige Signatur, genau darum kann nur die eigene Energie mit eben dieser einzigartiger Signatur optimal verarbeitet werden.  Fremdenergie enthält Komponenten, die nicht richtig interpretiert werden können. Das führt zu Funktionsstörungen im Energiefeld.",
            backgroundColor: "bg-yellow",
        },
        {
            title: "Finger weg von Manipulation ",
            text: "Manipulation heisst, einem Energiefeld ein Verhalten aufzuzwingen, was ihm nicht entspricht, um etwas bestimmtes zu erreichen. Durch diese Manipulation beginnt das Energiefeld zu rebellieren oder bricht vor Erschöpfung zusammen. Der Preis von Manipulationen ist viel höher als man es sich vorstellen kann.",
            backgroundColor: "bg-blue",
        },
        {
            title: "Wenig arbeiten, am richtigen Ort",
            text: "Nimmt ein Energiefeld Schaden, ist es entscheidend, direkt dort anzusetzen, wo die Verletzung aufgetreten ist und die Wurzeln des Problems zu finden. Aus meiner Erfahrung heraus zeigt sich oft, dass nur wenig Arbeit notwendig ist, wenn man am richtigen Punkt ansetzt. ",
            backgroundColor: "bg-pink",
        },
        {
            title: "Eigenes Heilungstempo",
            text: "Jeder Mensch hat ein eigenes Heilungstempo. Wird dies nicht beachtet, überfordert man das Energiefeld. Um optimale Ergebnisse zu erreichen, muss man im Takt des individuellen Heilungstempos arbeiten. Je intakter ein Energiefeld, desto schneller das Heilungstempo.",
            backgroundColor: "bg-turquoise",
        },
        {
            title: "Arbeiten, wo das Problem jetzt ist",
            text: "Wenn man sich nur auf die Verletzungen im Energiefeld aus der Vergangenheit konzentriert, besteht die Gefahr, dass sie verstärkt und Retraumatisierungen ausgelöst werden. Deshalb ist es wichtig, an den Verletzungen zu arbeiten, die unser Leben heute beeinträchtigen.",
            backgroundColor: "bg-[#4FB8E5]",
        },
        {
            title: "Es sind nie alle Energiefelder intakt",
            text: "Für jedes gelebte Jahr braucht man 2 bis 3 Jahre Therapie, wenn man alles verarbeiten will. Da aber die Therapie fürs Leben ist und nicht umgekehrt, macht es Sinn, nur an den Verletzungen zu arbeiten, die einen negativen Einfluss auf unser Leben haben.",
            backgroundColor: "bg-green",
        },
        {
            title: "Symptome und Ursachen",
            text: "Emotional sind wir mit seelischen Symptomen konfrontiert wie zum Beispiel: Traurigkeit, Überforderung oder Motivationslosigkeit. Wir nehmen  in der Regel lediglich die Auswirkungen von verletzten Energiefeldern wahr. Wichtig ist, an den Ursachen zu arbeiten und nicht Symptome zu füttern.",
            backgroundColor: "bg-orange",
        },
        {
            title: "Eigene Energiefeldsignatur",
            text: "Jedes Energiefeld folgt seinen eigenen Regeln. Bei der Energiefeldmechanik geht es darum, jeden zu lassen, wie er ist. Durch die Reparatur blockierter Energiefelder ist Entwicklung wieder möglich. Nur das garantiert, dass man die Kraft und Stabilität hat, sich selbst zu heilen und sich selbst zu sein. ",
            backgroundColor: "bg-purple",
        },
    ];
    return (
        <>
            <div className="bg-turquoise flex justify-center">
                <div className="container w-full px-9 md:px-20  py-28 flex-col justify-center items-center gap-6 inline-flex">
                    <div className="text-center">
                        <Title
                            hasColorTitle={true}
                            hasPreTitle={true}
                            preTitle="Worum geht’s: forschungsergebnisse waren nur mit dem praktischen ansatz möglich"
                            hasSubTitle={false}
                            hasText={true}
                            title="Immer schon auf Forschungskurs: das Warum ist Teil meiner DNA"
                            text="Ich wollte bis ins kleinste Detail verstehen, warum Energiefelder verletzt werden können und was ich tun muss, damit ich sie reparieren kann."
                            differentTextColor="text-lightYellow"
                            wordsInDifferentColor={["das", "Warum", "DNA"]}
                            paddings=""
                        />
                    </div>
                    <PlayerInPage
                        videoId="df5af6208df15c0876d8f209b7f925e6"
                        thumbnail="/images/thumbnails/ebnisseThumbnail1.jpg"
                    />
                </div>
            </div>
            <div className="bg-turquoise">
                <Triangles backgroundColor="bg-yellow" buttomToTop={true} />
            </div>
            <div className="bg-yellow flex justify-center">
                <div className="container w-full space-y-1 px-6  flex-col justify-start  gap-5 inline-flex">
                    <Testimonial
                        backgroundColor={TestimonialYellow.args?.backgroundColor}
                        description={TestimonialYellow.args?.description}
                        differentTextColor={TestimonialYellow.args?.differentTextColor}
                        wordsInDifferentColor={
                            TestimonialYellow.args?.wordsInDifferentColor
                        }
                        textColor={TestimonialYellow.args?.textColor}
                        hasDescription={TestimonialYellow.args?.hasDescription}
                        hasImage={TestimonialYellow.args?.hasImage}
                        name={TestimonialYellow.args?.name}
                        text={TestimonialYellow.args?.text}
                    />
                </div>
            </div>
            <div className="bg-yellow">
                <Triangles backgroundColor="bg-orange" buttomToTop={false} />
            </div>
            <div className="bg-orange w-full space-y-1 px-6 md:px-20 lg:px-32 flex-col justify-start  gap-5 inline-flex">
                <SideBySideText
                    reverse={true}
                    backgroundColor="bg-orange"
                    elementLeft={
                        <PlayerInPage
                            videoId="49798dc70d8a279ed2a7c705214553be"
                            thumbnail="/images/thumbnails/ebnisseThumbnail2.jpg"
                        />
                    }
                    elementRight={
                        <div className="flex flex-col space-y-3 pb-5 lg:pb-0">
                            <h1 className="text-xl3 text-black lg:text-5xl font-bold  lg:leading-14">
                                Entfremdet
                            </h1>

                            <div className=" text-black lg:text-xl1 text-lg  leading-7 lg:leading-10">
                                Wenn Energiefelder verletzt sind, verlieren wir uns
                                selbst und handeln nicht mehr authentisch.
                                Forschungsergebnisse haben schon früh darauf hingewiesen,
                                dass man nur mit funktionierenden Energiefeldern mit sich
                                selbst in Kontakt sein kann.{" "}
                            </div>
                        </div>
                    }
                    paddings="pb-28"
                />
            </div>
            <div className="bg-orange">
                <Triangles backgroundColor="bg-turquoise" buttomToTop={true} />
            </div>
            <div className="bg-turquoise w-full space-y-1 px-3 md:px-10 lg:px-32 flex-col justify-start  gap-5 inline-flex">
                <SideBySideText
                    backgroundColor="bg-turquoise"
                    paddings="space-y-10 py-25 px-3 md:space-x-14 lg:px-32 md:px-8"
                    elementLeft={
                        <Title
                            hasColorTitle={false}
                            hasPreTitle={false}
                            hasSubTitle={false}
                            hasText={false}
                            title="Die Einzigartigkeit folgt keinen Standards"
                            paddings=""
                            textAlignment="left"
                            titleSize="text-[40px] md:text-[80px] lg:text-[80px]"
                            leadingTitle="lg:leading-[80px] md:leading-[80px] leading-[52px]"
                        />
                    }
                    elementRight={
                        <Text
                            title="Der Eintritt in die faszinierende Welt der Energiefelder ist die Beobachtungsgabe"
                            paragraphs={[
                                "Die Einzigartigkeit und Individualität von Energiefeldern zu erkennen, ist erst ab einem tiefen Verständnis möglich. Denn auf die Schnelle und oberflächlich betrachtet, sind sich viele Energiefelder ähnlich. Im Detail betrachtet könnten Energiefelder unterschiedlicher nicht sein, man kann sagen, dass jedes Energiefeld auf seine eigene Art ein wenig eigenwillig ist.",
                                "Jedes Energiefeld ist einzigartig. Es reagiert anders, hat seine eigenen Prozesse und folgt einer individuellen Logik. Genau das macht die Reparatur von Energiefeldern so herausfordernd zu erklären. Es gibt keine festen Regeln oder Standardverfahren. Stattdessen gibt es unendlich viele Variationen.",
                            ]}
                            paddings=""
                            leading=" lg:leading-14 leading-10"
                            leadingText="lg:leading-8.5 leading-7"
                            hasReadMore={true}
                            paragraphSlice={1}
                        />
                    }
                />
            </div>
            <div className="bg-turquoise">
                <Triangles backgroundColor="bg-yellow" buttomToTop={false} />
            </div>
            <div className="bg-yellow flex justify-center">
                <div className="container w-full pt-28 md:px-20 pb-20 space-y-2 px-3 flex-col justify-center  items-center  inline-flex">
                    <div className=" text-center text-black lg:text-xl3 text-2xl font-bold  lg:leading-10 leading-loose">
                        Das Wissen liegt im Detail
                    </div>
                    <Title
                        hasPreTitle={false}
                        preTitle="Das Wissen liegt im Detail"
                        title="Energiefelder sind so einzigartig,  ihre Eigenheiten müssen im Fokus stehen"
                        text="Man muss die kleinsten Zusammenhänge verstehen, um die Grossen zu sehen"
                        hasColorTitle={false}
                        hasSubTitle={false}
                        hasText={true}
                        paddings="px-3  "
                    />

                    <PlayerInPage
                        videoId="85d8540e0bd05889a3dc51dbabd362f1"
                        thumbnail="/images/thumbnails/ebnisseThumbnail3.jpg"
                    />
                </div>
            </div>
            <div className="bg-yellow">
                <Triangles backgroundColor="bg-white" buttomToTop={true} />
            </div>
            <div className="bg-white flex justify-center">
                <div className="container w-full space-y-1   pb-20 flex-col justify-start  gap-5 inline-flex">
                    <SliderNoArrows
                        paginationColor="#000000"
                        contentEl={
                            <div className="flex justify-center items-center">
                                {shuffle(testimonials?.testimonials)?.map(
                                    (testimonial) => {
                                        return (
                                            <SwiperSlide key={testimonial.name}>
                                                <Testimonial
                                                    backgroundColor={
                                                        TestimonialLight?.args
                                                            ?.backgroundColor
                                                    }
                                                    differentTextColor={
                                                        TestimonialLight?.args
                                                            ?.differentTextColor
                                                    }
                                                    hasImage={testimonial.hasImage}
                                                    text={testimonial?.testimonial}
                                                    icon={TestimonialLight.args?.icon}
                                                    textColor={
                                                        TestimonialLight.args?.textColor
                                                    }
                                                    name={testimonial?.name}
                                                    hasDescription={false}
                                                    wordsInDifferentColor={[""]}
                                                    hasReadMore={true}
                                                />
                                            </SwiperSlide>
                                        );
                                    },
                                )}
                            </div>
                        }
                    />
                    <div className=" text-center text-black text-xl3 pt-16 lg:pt-25 lg:text-5xl font-bold  leading-10 lg:leading-14">
                        Wichtige Forschungsergebnisse zusammengefasst
                    </div>
                    <div className="flex justify-center ">
                        <div className="lg:grid md:grid md:space-y-0 md: gap-5 grid-cols-2 md:grid-cols-2 space-y-5 lg:gap-5  text-center lg:space-y-0">
                            {colorCards.map((card) => (
                                <div key={card.title}>
                                    <Card
                                        width={CardMdColor.args?.width}
                                        height={CardMdColor.args?.height}
                                        backgroundColor={card.backgroundColor}
                                        border={CardMdColor.args?.border}
                                        hasButton={CardMdColor.args?.hasButton}
                                        hasImage={CardMdColor.args?.hasImage}
                                        hasList={CardMdColor.args?.hasList}
                                        hasPretitle={CardMdColor.args?.hasPretitle}
                                        hasText={CardMdColor.args?.hasText}
                                        title={card.title}
                                        content={card.text}
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
            <div className="bg-white">
                <Triangles backgroundColor="bg-orange" buttomToTop={false} />
            </div>
            <div className="bg-orange flex justify-center">
                <div className="container w-full space-y-1 px-3 flex-col justify-start  gap-5 inline-flex">
                    <Newsletter
                        backgroundColor="bg-orange"
                        buttonText="HOL DIR DIE  MASTERCLASS"
                        hasCheckbox={false}
                        hasDescription={true}
                        hasInput={false}
                        hasSubText={false}
                        title="Willst du mehr erfahren?"
                        paddings="lg:px-80 px-3 py-25 "
                        buttonAs="a"
                        href="/de/masterclass#masterclassSection"
                        buttonPaddings="lg:px-10 px-3 py-4"
                        description="Ich lade dich herzlich zu meiner Videosammlung Masterclass ein. Hier dreht sich alles um das faszinierende Thema Energiefelder. Es ist mir wichtig, dass jeder, die Möglichkeit hat, von diesem Wissen zu profitieren."
                        onClickButton={() => {
                            sendGTMEvent({
                                event: "cta_click",
                                section_title: "Willst du mehr erfahren?",
                                section_index: "5",
                                cta_text: "HOL DIR DIE  MASTERCLASS",
                                cta_link: `${process.env.NEXT_PUBLIC_URL}/de/masterclass#masterclassSection`,
                            });
                        }}
                    />
                </div>
            </div>
            <div className="bg-orange">
                <Triangles backgroundColor="bg-darkGray" buttomToTop={true} />
            </div>
        </>
    );
}
